import * as React from 'react'
import MUIBox from '@mui/material/Box'

const Box = (props) => <MUIBox {...props} />

export default Box
